import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Typography,
} from "@mui/material";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ButtonCloseSesion } from "./ButtonCloseSesion.jsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 650,
  minWidth: 300,
  bgcolor: "primary.main",
  boxShadow: 24,
  padding: "50px 10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
};

export const ModalMenu = ({ menuIsOpen, setMenuIsOpen }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("global");
  const { role } = useSelector((state) => state.auth);

  // const handleClose = () => {
  //     setMenuIsOpen(false)
  // }

  const goClick = (url) => {
    navigate(url);
    setMenuIsOpen(false);
  };

  return (
    <>
      <Modal
        open={menuIsOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Divider
            color="white"
            sx={{ marginBottom: "25px", marginTop: "10px" }}
          />
          <List>
            {role === "Admin" && (
              <>
                <ListItem button onClick={() => goClick("/partners")}>
                  <ListItemIcon>
                    <PeopleAltSharpIcon color="info" />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography color="info.main" variant="h6">
                      {t("drawer.partners")}
                    </Typography>
                  </ListItemText>
                </ListItem>

                <ListItem button onClick={() => goClick("/startup")}>
                  <ListItemIcon>
                    <StoreOutlinedIcon color="info" />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography color="info.main" variant="h6">
                      {" "}
                      Startups{" "}
                    </Typography>
                  </ListItemText>
                </ListItem>
                <ListItem button onClick={() => goClick("/vehicle")}>
                  <ListItemIcon>
                    <ManageAccountsIcon color="info" />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography color="info.main" variant="h6">
                      {" "}
                      {t("drawer.vehicles")}{" "}
                    </Typography>
                  </ListItemText>
                </ListItem>
              </>
            )}

            {(role === "Club" || role === "Híbrido" || role === "Admin") && (
              <ListItem button onClick={() => goClick("/opportunities")}>
                <ListItemIcon>
                  <AddchartOutlinedIcon color="info" />
                </ListItemIcon>
                <ListItemText>
                  <Typography color="info.main" variant="h6">
                    {t("drawer.opportunitiesItems")}
                  </Typography>
                </ListItemText>
              </ListItem>
            )}

            <ListItem button onClick={() => goClick("/events")}>
              <ListItemIcon>
                <CalendarMonthOutlinedIcon color="info" />
              </ListItemIcon>
              <ListItemText>
                <Typography color="info.main" variant="h6">
                  {t("drawer.eventsItems")}
                </Typography>
              </ListItemText>
            </ListItem>

            {(role === "Club" || role === "Híbrido" || role === "Admin") && (
              <ListItem button onClick={() => goClick("/positions")}>
                <ListItemIcon>
                  <InsertChartOutlinedIcon color="info" />
                </ListItemIcon>
                <ListItemText>
                  <Typography color="info.main" variant="h6">
                    {t("drawer.positionItems")}
                  </Typography>
                </ListItemText>
              </ListItem>
            )}
            {(role === "LP" || role === "Híbrido" || role === "Admin" || role === "Club") && (
              <ListItem button onClick={() => goClick("/positionsLP")}>
                <ListItemIcon>
                  <InsertChartOutlinedIcon color="info" />
                </ListItemIcon>
                <ListItemText>
                  <Typography color="info.main" variant="h6">
                    {t("drawer.divestments")}
                  </Typography>
                </ListItemText>
              </ListItem>
            )}
          </List>
          <ButtonCloseSesion size="big" />
        </Box>
      </Modal>
    </>
  );
};
